import { useTranslation } from 'react-i18next';
import './style.scss';

type HeaderProps = {
  email: string;
  isBulkOrder?: boolean;
};

export const Header = ({ email, isBulkOrder = false }: HeaderProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <span className="order-confirmation-header__title">
        {isBulkOrder
          ? t('confirmation.bulkMessage')
          : t('confirmation.message')}
      </span>
      <p className="order-confirmation-header__instruction">
        {t('confirmation.instructions')}
        <span>{email}</span> {t('confirmation.instructions2')}
      </p>
    </div>
  );
};
